import { inject, Injectable } from '@angular/core'
import { AssistanceOccupation, WorkerAvailability } from '../../../models/workerAvailability'
import { AssistanceStatusesService } from '../codelists/assistance-statuses.service'
import { defaultIfEmpty, first, map } from 'rxjs/operators'
import { forkJoin, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class WorkerAvailabilitiesOccupationService {
  private statusService = inject(AssistanceStatusesService)

  private TAG = 'WorkerAvailabilitiesOccupationService'

  private computeOccupationsFromAssignments(a: WorkerAvailability): Observable<AssistanceOccupation[]> {
    const occupations: AssistanceOccupation[] = []

    const negativeStatusIds$ = this.statusService.getAll().pipe(
      first(),
      map((ss) => ss.filter((s) => s.isNegative()).map((s) => s.id)),
    )

    return negativeStatusIds$.pipe(
      map((negativeStatusIds) => {
        if (a.assistantAssignments) {
          for (const assistance of a.assistantAssignments.getUniqueAssistances()) {
            if (negativeStatusIds.includes(assistance.statusId as number)) continue
            // console.log(this.TAG, 'assistanceOccupationsFromAssistanceAssignments', assistance)
            const o = new AssistanceOccupation()
            o.dateFrom = assistance.getDateFrom()
            o.dateTo = assistance.getDateTo()
            o.client = assistance.client
            occupations.push(o)
          }
        }
        return occupations
      }),
    )
  }

  addOccupationsAndVacantTimes(a: WorkerAvailability): Observable<WorkerAvailability> {
    // const occupations = this.computeOccupationsFromAssignments(a)

    return this.computeOccupationsFromAssignments(a).pipe(
      map((occupations) => {
        a.assistanceOccupations = occupations

        a.remainingVacantTimes = a.getRemainingVacantTimes()

        if (a.assistanceOccupations) {
          for (let i = 0; i < a.assistanceOccupations.length; i++) {
            const o = new AssistanceOccupation()
            o.dateTo = a.assistanceOccupations[i].dateTo
            o.dateFrom = a.assistanceOccupations[i].dateFrom
            o.client = a.assistanceOccupations[i].client
            a.assistanceOccupations[i] = o
          }
        }
        return a
      }),
    )
  }

  addOccupationsAndVacantTimesMulti(aa: WorkerAvailability[]): Observable<WorkerAvailability[]> {
    const observables: Observable<WorkerAvailability>[] = []

    aa.map((a) => {
      observables.push(this.addOccupationsAndVacantTimes(a).pipe(first()))
    })

    return forkJoin(observables).pipe(defaultIfEmpty([]))
  }
}
